import React from 'react';

// Design tokens
const DS = {
  trackBg: '#1a1a1a',
  trackH: 4,
  trackRadius: 2,
  accent: '#F97316',
  dotSize: 14,
  playSize: 32,
  pillH: 44,
  pillRadius: 22,
  pillBorder: '0.5px solid #e5e5e5',
  pillFont: { fontSize: 13, fontWeight: 500, fontFamily: "'DM Sans', sans-serif", color: '#F97316' },
  pctFont: { fontSize: 11, fontWeight: 500, fontFamily: "'DM Sans', sans-serif", color: '#F97316' },
  labelFont: { fontSize: 11, fontFamily: "'DM Sans', sans-serif", letterSpacing: 0.5, color: '#888' },
};

export function Pill({ children, style }) {
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
      height: DS.pillH, padding: '0 16px',
      border: DS.pillBorder, borderRadius: DS.pillRadius,
      background: 'white', ...DS.pillFont, flexShrink: 0, ...style
    }}>{children}</span>
  );
}

export function PlayBtn({ onClick, playing, size, style }) {
  const s = size || DS.playSize;
  return (
    <button onClick={onClick} style={{
      width: s, height: s, borderRadius: '50%',
      background: playing ? DS.accent : 'white',
      border: `1px solid ${DS.trackBg}`,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      cursor: 'pointer', flexShrink: 0, padding: 0, ...style
    }}>
      {playing
        ? <div style={{ width: s * 0.25, height: s * 0.25, background: '#fff', borderRadius: 1 }} />
        : <svg width={s * 0.375} height={s * 0.375} viewBox="0 0 24 24" fill={DS.trackBg}>
            <path d="M8 5v14l11-7z"/>
          </svg>}
    </button>
  );
}

export function ToggleBar({ options, active, onChange, disabled, style }) {
  return (
    <div style={{
      display: 'flex', width: '100%', borderRadius: 8, overflow: 'hidden',
      border: '0.5px solid #e5e5e5', ...style
    }}>
      {options.map(opt => (
        <button key={opt.value} onClick={() => onChange(opt.value)}
          disabled={disabled}
          style={{
            flex: 1, height: 36, border: 'none', cursor: disabled ? 'not-allowed' : 'pointer',
            fontFamily: "'DM Sans', sans-serif", fontSize: 11,
            background: active === opt.value ? DS.trackBg : '#f5f5f5',
            color: active === opt.value ? 'white' : '#888',
            opacity: disabled ? 0.35 : 1,
          }}>{opt.label}</button>
      ))}
    </div>
  );
}

export function SectionLabel({ children }) {
  return <div style={{ ...DS.labelFont, marginBottom: 8 }}>{children}</div>;
}

export function Pct({ value }) {
  return <span style={{ ...DS.pctFont, minWidth: 32, textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}>{Math.round(value)}%</span>;
}

export { DS };
